import { NavLink, useNavigate } from "react-router-dom";
import { ReactComponent as JHULogo } from "../../assets/jhu-logo.svg";
import { ReactComponent as BioData } from "../../assets/biodata.svg";
import { ReactComponent as Institute } from "../../assets/institute.svg";
import { ReactComponent as WorkHistory } from "../../assets/workHistory.svg";
import { ReactComponent as Payments } from "../../assets/payment.svg";
import { ReactComponent as Dashboard } from "../../assets/dashboard.svg";
import { ReactComponent as Logout } from "../../assets/Logout (1).svg";
import { ReactComponent as Printer } from "../../assets/printer.svg";
import { ReactComponent as FileIcon } from "../../assets/file.svg";
import styles from "./dashboardLayout.module.scss";
import { userAtom } from "../../utils/store";
import { useAtomValue } from "jotai";
import { routes } from "../../routes";
import { logout } from "../../utils/logout";
import { getNormalizedModeOfEntry } from "../../utils";

const Sidebar = () => {
  const navigate = useNavigate();
  const user = useAtomValue(userAtom);

  const handleNavigateToHome = () => {
    navigate(routes.auth.landing);
  };

  const normalizedModeOfEntry = getNormalizedModeOfEntry(user?.modeOfEntry);
  const isUtmeApplicant = normalizedModeOfEntry?.includes("utme");

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.logo}>
          <JHULogo onClick={handleNavigateToHome} />
        </div>
      </div>

      <nav className={styles.sidebarNav}>
        <NavLink
          className={({ isActive }) =>
            isActive ? styles.activeLink : styles.nonActive
          }
          to={"/dashboard"}
        >
          <span className={styles.link}>
            <span>
              <Dashboard />
            </span>

            <span className={styles.linkText}>Dashboard</span>
          </span>
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            isActive ? styles.activeLink : styles.nonActive
          }
          to={routes.dashboard.applicationForm}
        >
          <span className={styles.link}>
            <span>
              <Printer />
            </span>

            <span className={styles.linkText}>Application Form</span>
          </span>
        </NavLink>

        <NavLink
          className={({ isActive }) =>
            isActive ? styles.activeLink : styles.nonActive
          }
          to={routes.dashboard.admissionStatus}
        >
          <span className={styles.link}>
            <span>
              <Printer />
            </span>

            <span className={styles.linkText}>Admission Status</span>
          </span>
        </NavLink>

        <NavLink
          className={({ isActive }) => (isActive ? styles.activeLink : "")}
          to={"/bio-data"}
        >
          <span className={styles.link}>
            <span>
              <BioData />
            </span>

            <span className={styles.linkText}>Bio-data</span>
          </span>
        </NavLink>

        {user &&
          (user?.programType?.toLowerCase()?.includes("msc") ||
            user?.programType?.toLowerCase()?.includes("mba") ||
            normalizedModeOfEntry?.includes("directentry")) && (
            <NavLink
              className={({ isActive }) => (isActive ? styles.activeLink : "")}
              to={"/institute"}
            >
              <span className={styles.link}>
                <span>
                  <Institute />
                </span>

                <span className={styles.linkText}>Institution</span>
              </span>
            </NavLink>
          )}

        {user && user?.programType?.toLowerCase()?.includes("bsc") && (
          <NavLink
            className={({ isActive }) => (isActive ? styles.activeLink : "")}
            to={"/qualification"}
          >
            <span className={styles.link}>
              <span>
                <Institute />
              </span>

              <span className={styles.linkText}>Qualification</span>
            </span>
          </NavLink>
        )}

        {user &&
          user?.programType?.toLowerCase()?.includes("bsc") &&
          isUtmeApplicant && (
            <NavLink
              className={({ isActive }) => (isActive ? styles.activeLink : "")}
              to={routes.dashboard.utmeResult}
            >
              <span className={styles.link}>
                <span>
                  <Institute />
                </span>

                <span className={styles.linkText}>UTME Result</span>
              </span>
            </NavLink>
          )}

        {(user?.programType?.toLowerCase()?.includes("msc") ||
          user?.programType?.toLowerCase()?.includes("mba")) && (
          <NavLink
            className={({ isActive }) => (isActive ? styles.activeLink : "")}
            to={"/work-history"}
          >
            <span className={styles.link}>
              <span>
                <WorkHistory />
              </span>

              <span className={styles.linkText}>Work History</span>
            </span>
          </NavLink>
        )}

        <NavLink
          className={({ isActive }) => (isActive ? styles.activeLink : "")}
          to={routes.dashboard.requiredDocuments}
        >
          <span className={styles.link}>
            <span>
              <WorkHistory />
            </span>

            <span className={styles.linkText}>Required Document</span>
          </span>
        </NavLink>

        <NavLink
          className={({ isActive }) => (isActive ? styles.activeLink : "")}
          to={"/payments"}
        >
          <span className={styles.link}>
            <span>
              <Payments />
            </span>

            <span className={styles.linkText}>Payments</span>
          </span>
        </NavLink>

        <span className={styles.logout} onClick={logout}>
          <span className={styles.link}>
            <span>
              <Logout />
            </span>
            Logout
          </span>
        </span>
      </nav>
    </>
  );
};

export default Sidebar;
